const ApiPrefix = "v1",
  ReqTimeout = 10000,
  ReqRetry = 4,
  ReqRetryDelay = 800,
  SiteName = "可酷酷 - 汉字之美",
  UserInfoKey = "HZZM_USER_INFO",
  UserTokenKey = "HZZM_ACCESS_TOKEN";

export {
  ApiPrefix,
  ReqTimeout,
  ReqRetry,
  ReqRetryDelay,
  SiteName,
  UserInfoKey,
  UserTokenKey
};
